import { render, staticRenderFns } from "./deliver_type_id_input.vue?vue&type=template&id=50cbe4c8&lang=pug&"
import script from "./deliver_type_id_input.vue?vue&type=script&lang=js&"
export * from "./deliver_type_id_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports